import Choices from "Choices.js"

export class WasteSchedule
{
    tabs = document.querySelector('[data-s~="Tabs"]');
    citySelect = document.querySelector('[data-s~="City:select"]');
    streetSelect = document.querySelector('[data-s~="Street:select"]');
    houseNoSelect = document.querySelector('[data-s~="HouseNo:select"]');
    yearSelect = document.querySelector('[data-s~="Year:select"]');
    wasteList = document.querySelector('[data-s~="WasteSchedule:list:1"]');
    wasteCalendar = document.querySelector('[data-s~="WasteSchedule:calendar:1"]');
//    wasteListCaption = this.tabs && this.wasteList.querySelector(':scope caption span');
//    wasteListCaption1 = this.tabs && this.wasteList.querySelector(':scope [data-s~="WasteSchedule:caption:1"]');
//    wasteListCaption2 = this.tabs && this.wasteList.querySelector(':scope [data-s~="WasteSchedule:caption:2"]');
    wasteCalendarCaption = this.tabs && this.wasteCalendar.querySelector(':scope div span');
    wasteCalendarCaption1 = this.tabs && this.wasteCalendar.querySelector(':scope [data-s~="WasteSchedule:caption:3"]');
    wasteCalendarCaption2 = this.tabs && this.wasteCalendar.querySelector(':scope [data-s~="WasteSchedule:caption:4"]');
    wasteListCellSelector = 'WasteSchedule:cell:';
    wasteCalendarTableSelector = 'WasteSchedule:calendar:table:';
    citiesChoices;
    streetChoices;
    houseNoChoices;
    yearChoices;

    constructor(store)
    {
        this.store = store;
        this.txt = this.store.data.service.WasteSchedule.txt;
    }

    prepareDataToSend(dataToCode)
    {
        let dataPart = [];
        for (let key in dataToCode) {
            dataPart.push(encodeURIComponent(key) + "=" + encodeURIComponent(dataToCode[key]));
        }
        return dataPart.join("&").replace(/%20/g, "+");
    }

    communicateWithBackend(cityId, streetId = '', houseNo = '', year = '')
    {
        const data = {
//            rand: this.cfRand.value,
//            token: this.cfToken.value,
            cityId: cityId,
            streetId: streetId,
            houseNo: houseNo,
            year: year
//            contactForm_recaptcha_verification: this.cfRecaptcha.value
        };
        const dataToSend = this.prepareDataToSend(data);

        return fetch('/ajax/waste_schedule.php', {
            method: 'POST',
//            mode: 'cors',
            cache: 'no-cache',
//            credentials: 'same-origin',
            headers: {
//                'Content-Type': 'application/json'
                'Content-Type': 'application/x-www-form-urlencoded'
            },
//            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: dataToSend
        }).then(response => {
            return response.json();
        });
    }

    showTabs()
    {
        this.tabs.dataset.d = this.tabs.dataset.d.replace('dy=ne', '');
    }

    resetCaption()
    {
        this.wasteCalendarCaption1.innerText = '';
        this.wasteCalendarCaption2.innerText = '';
    }

    setCaption(streetName, year)
    {
//        this.wasteListCaption.dataset.d = this.wasteListCaption.dataset.d.replace('dy=ne', '');
//        this.wasteListCaption1.innerText = year;
//        this.wasteListCaption2.innerText = streetName;

        this.wasteCalendarCaption.dataset.d = this.wasteCalendarCaption.dataset.d.replace('dy=ne', '');
        this.wasteCalendarCaption1.innerText = year;
        this.wasteCalendarCaption2.innerText = streetName;
    }

    clearWasteList()
    {
        this.wasteList.querySelectorAll(':scope td').forEach(e => {
            e.innerText = null;
        });
    }

    clearWasteCalendars()
    {
        for (let i = 1; i <= 12; i ++) {
            let tbody = document.querySelector('[data-s~="' + this.wasteCalendarTableSelector + i + '"] > tbody');
            tbody.innerText = null;
        }
    }

    createList(listData)
    {
        listData.forEach(dataObj => {
            let wasteId = dataObj.wasteId;
            let month = dataObj.month;
            let date = dataObj.date;

            let cell = this.wasteList.querySelector(':scope [data-s~="' + this.wasteListCellSelector + month + '_' + wasteId + '"]');
            let dateDiv = document.createElement('div');
            dateDiv.innerText = date;
            cell.appendChild(dateDiv);
        });
    }

    prepareImagesForCalendar(calendarData, month)
    {
        let wasteDays = [];
        for (let k in calendarData) {
            if (calendarData[k].month === month) {
                wasteDays.push({
                    'day': calendarData[k].day,
                    'img': calendarData[k].img,
                    'color': calendarData[k].color,
                    'fontColor': calendarData[k].fontColor,
                    'monthName': calendarData[k].monthName,
                    'wasteName': calendarData[k].wasteName
                });
            }
        }

        return wasteDays;
    }

    getWasteAmountPerDay(wasteDays, day)
    {
        let imgCount = 0;

        wasteDays.forEach(e => {
            if (parseInt(day) === parseInt(e.day)) {
                imgCount ++;
            }
        });

        return imgCount;
    }

    createCalendars(yearData, calendarData)
    {
        for (let i in yearData) {
            let daysInMonth = yearData[i].daysInMonth;
            let dayOfWeek = yearData[i].dayOfWeek;
            let dayOfWeekCorrected = yearData[i].dayOfWeekCorrected;

            let tr, td, dayOfWeekTemp, restOfWeek, wasteDays;
            dayOfWeekTemp = 0;
            tr = document.createElement('tr');

            if (dayOfWeekCorrected !== 1) {
                dayOfWeekTemp = dayOfWeekCorrected - 1;
                td = document.createElement('td');
                td.dataset.d = 'br=ne';
                td.setAttribute('colspan', dayOfWeekTemp);
                tr.appendChild(td);
            }

            wasteDays = this.prepareImagesForCalendar(calendarData, i);

            for (let j = 1; j <= daysInMonth; j ++) {
                dayOfWeekTemp ++;
                td = document.createElement('td');
                td.setAttribute('headers', 'day-' + dayOfWeekTemp);
                td.dataset.d = 'ft-fy=2-rr ft-se=12rem co=bk le-ht=1.2 ft-wt=nl pg=2px ht=30px br-cr=3 br-se=sd br-wh=1px tt-an=cr vl-an=me pn=re';
                td.dataset.c = 'br-cr=bk';
                td.classList.add('htmltopdf__wasteschedule__calendar__day');

                let imgCount = this.getWasteAmountPerDay(wasteDays, j);
                let img, gradStop;
                let gradStart = 0;
                let gradDelta = gradStop = (100 / imgCount);
                let gradString = '';
                let fontColor = 'co=bk';
                let div = document.createElement('div');
                div.dataset.d = 'pn=ae wh=100% ht=100% lt=0 tp=0 le-ht=0';
                div.classList.add('htmltopdf__remove');

                wasteDays.forEach(e => {
                    if (parseInt(j) === parseInt(e.day)) {
                        img = document.createElement('img');
                        img.setAttribute('src', '/resources/waste/' + e.img);
                        img.setAttribute('alt', '');
                        img.dataset.d = 'dy=bk wh=100%';
                        img.style = 'height: ' + (100 / imgCount) + '%';
                        img.setAttribute('title', `${e.day} ${e.monthName}: ${e.wasteName}`);

                        gradString += (e.color + ' ' + gradStart + '%, ' + e.color + ' ' + gradStop + '%, ');
                        gradStart += gradDelta;
                        gradStop += gradDelta;

                        div.appendChild(img);
                        fontColor = (e.fontColor === 'co=bk') ? 'co=bk' : e.fontColor;
                    }
                });
                if (gradString.length > 0) {
                    gradString = 'background: linear-gradient(180deg, ' + gradString.slice(0, -2) + '); color: #fff;';
                    td.style = gradString;
                }

                let span = document.createElement('span');
                span.dataset.d = 'pn=re ' + fontColor;
                span.innerText = j;

                td.appendChild(div);
                td.appendChild(span);
                tr.appendChild(td);

                let tbody = document.querySelector('[data-s~="' + this.wasteCalendarTableSelector + i + '"] > tbody');

                if (dayOfWeekTemp === 7) {
                    dayOfWeekTemp = 0;
                    tbody.appendChild(tr);
                    tr = document.createElement('tr');
                }

                if (dayOfWeekTemp !== 7 && j === daysInMonth) {
                    tbody.appendChild(tr);
                }


            }
        }
    }

    getStreets(cityId)
    {
        this.communicateWithBackend(cityId, '', '', '').then(response => {
//            if (response !== 'token_error' && response !== 'recaptcha_error') {
//
            let streetValues = [];
            Object.entries(response.streets).forEach(e => {
                const [key, value] = e;

                streetValues.push({ value: key, label: value});
            });
            streetValues.push({ value: 0, label: this.txt[4], selected: true, disabled: true});

            this.streetChoices.clearChoices().setChoices(streetValues);
            this.streetChoices.enable();
        });
    }

    getHouseNumbers(cityId, streetId)
    {
        this.communicateWithBackend(cityId, streetId, '', '').then(response => {
//            if (response !== 'token_error' && response !== 'recaptcha_error') {
            let houseNoValues = [];
            Object.entries(response.houseNo).forEach(e => {
                const [key, value] = e;

                houseNoValues.push({ value: value.toString(), label: value.toString()});
            });
            houseNoValues.push({ value: 0, label: this.txt[4], selected: true, disabled: true});

            this.houseNoChoices.clearChoices().setChoices(houseNoValues);
            this.houseNoChoices.enable();
            this.enableYearsChoices(response.years);
        });
    }

    enableYearsChoices(years)
    {
        let yearsValues = [];
        Object.entries(years).forEach(e => {
            const [key, value] = e;

            yearsValues.push({ value: value.toString(), label: value.toString()});
        });

        this.yearChoices.enable();
        this.yearChoices.clearChoices().setChoices(yearsValues);
    }

    getSchedule(cityId, streetId, houseNo, year)
    {
        this.communicateWithBackend(cityId, streetId, houseNo, year).then(response => {
//            if (response !== 'token_error' && response !== 'recaptcha_error') {
                this.showTabs();
                this.clearWasteList();
                this.clearWasteCalendars();
                this.setCaption(response.streetName, response.year);
                this.createList(response.listData);
                this.createCalendars(response.yearData, response.calendarData);
        });
    }

    handle()
    {
        this.citiesChoices = new Choices(this.citySelect, {
            searchPlaceholderValue: this.txt[3],
            noResultsText: this.txt[1],
            labelId: 'cityLabel',
            searchFloor: 2,
            itemSelectText: this.txt[2],
            placeholderValue: this.txt[4],
            noChoicesText: this.txt[7],
            position: 'bottom'
        });
        this.citiesChoices.containerOuter.element.setAttribute('aria-controls', 'waste-street waste-house-no waste-tabs');

        this.streetChoices = new Choices(this.streetSelect, {
            searchPlaceholderValue: this.txt[5],
            noResultsText: this.txt[1],
            labelId: 'streetLabel',
            searchFloor: 2,
            itemSelectText: this.txt[2],
            placeholderValue: this.txt[4],
            noChoicesText: this.txt[7],
            position: 'bottom'
        });
        this.streetChoices.containerOuter.element.setAttribute('aria-controls', 'waste-house-no waste-tabs');

        this.houseNoChoices = new Choices(this.houseNoSelect, {
            searchPlaceholderValue: this.txt[6],
            noResultsText: this.txt[1],
            labelId: 'houseNoLabel',
            searchFloor: 2,
            itemSelectText: this.txt[2],
            placeholderValue: this.txt[4],
            noChoicesText: this.txt[8],
            position: 'bottom'
        });
        this.houseNoChoices.containerOuter.element.setAttribute('aria-controls', 'waste-tabs');

        this.yearChoices = new Choices(this.yearSelect, {
            searchEnabled: false,
            labelId: 'yearLabel',
            itemSelectText: this.txt[2],
            position: 'bottom'
        });
        this.yearChoices.containerOuter.element.setAttribute('aria-controls', 'waste-tabs');

        this.citySelect.addEventListener('choice', (e) => {
            this.clearWasteList();
            this.clearWasteCalendars();
            this.resetCaption();
            this.streetChoices.disable();
            this.houseNoChoices.disable();
            let cityId = e.detail.choice.value;

            this.getStreets(cityId);
        });

        this.streetSelect.addEventListener('choice', (e) => {
            this.clearWasteList();
            this.clearWasteCalendars();
            this.resetCaption();
            this.houseNoChoices.disable();
            let cityId = this.citiesChoices.getValue(true);
            let streetId = e.detail.choice.value;

            this.getHouseNumbers(cityId, streetId);
        });
        this.streetSelect.addEventListener('showDropdown', (e) => {
            if (this.streetChoices.choiceList.element.querySelector(':scope [data-value="0"]')) {
                this.streetChoices.choiceList.element.querySelector(':scope [data-value="0"]').remove();
            }
        });

        this.houseNoSelect.addEventListener('choice', (e) => {
            let cityId = this.citiesChoices.getValue(true);
            let streetId = this.streetChoices.getValue(true);
            let houseNo = e.detail.choice.value;
            let year = this.yearChoices.getValue(true);

            this.getSchedule(cityId, streetId, houseNo, year);
        });
        this.houseNoSelect.addEventListener('showDropdown', (e) => {
            if (this.houseNoChoices.choiceList.element.querySelector(':scope [data-value="0"]')) {
                this.houseNoChoices.choiceList.element.querySelector(':scope [data-value="0"]').remove();
            }
        });

        this.yearSelect.addEventListener('choice', (e) => {
            let cityId = this.citiesChoices.getValue(true);
            let streetId = this.streetChoices.getValue(true);
            let houseNo = this.houseNoChoices.getValue(true);
            let year = e.detail.choice.value;

            this.getSchedule(cityId, streetId, houseNo, year);
        });
    }

    run()
    {
        document.addEventListener('DOMContentLoaded', () => {
            this.tabs && this.handle();
        });
    }
}